// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import LaborRate from '@deere/cps-it.warranty-model-factory/lib/labor-rate';
import {postLaborRates} from '../../shared/repositories';
import {routerActions} from 'react-router-redux';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';

export const postLaborRateChange = laborRate =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const updatedLaborRate = new LaborRate({
                ...laborRate,
                requestStatus: {
                    key: 'NEW',
                    value: 'NEW'
                }
            });

            await postLaborRates(updatedLaborRate);

            successAlertBar(translate('LABOR_RATE_CHANGE_SUBMITTED'));
            dispatch(routerActions.push('/claims/labor-rates'));

        } catch (error) {
        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/labor-rate-change/action-creators/post-labor-rate.js